import { compose, withProps, withState, lifecycle, withHandlers } from 'recompose'
import { isEqual } from 'lodash'
import TireLinesList from './TireLinesList'

const withLastRow = withState('capRow', 'setCapRow', 0)
const withObserver = withState('intersectionObserver', 'setObserver', null)

const withCappedProducts = withProps(({ products, capRow }) => {
  const cappedProducts = products.slice(0, capRow)
  return {
    cappedProducts,
    displayingAllItems: cappedProducts.length === products.length
  }
})

const withStateHandlers = withHandlers({
  increaseCapRow: ({ capRow, setCapRow }) => () => setCapRow(capRow + 1)
})

const withObserverLifecycle = lifecycle({
  componentDidMount() {
    const { setObserver, increaseCapRow } = this.props

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.25, 0.5, 0.75, 1]
    }
    const intersectionObserver = new IntersectionObserver(entries => {
      entries.every(entry => entry.isIntersecting) && increaseCapRow()
    }, observerOptions)

    setObserver(intersectionObserver)
    increaseCapRow()
  },

  componentDidUpdate({ capRow: prevCapRow, products: prevProducts }) {
    const { capRow, intersectionObserver, products, setCapRow } = this.props
    if (prevCapRow !== capRow && intersectionObserver) {
      const prevTireRow = document.querySelector(`#tire_row_${prevCapRow}`)
      const currentTireRow = document.querySelector(`#tire_row_${capRow}`)
      currentTireRow && intersectionObserver.observe(currentTireRow)
      prevTireRow && intersectionObserver.unobserve(prevTireRow)
    }

    if (!isEqual(prevProducts, products)) {
      intersectionObserver.disconnect()
      setCapRow(1)
    }
  }
})

export default compose(
  withLastRow,
  withObserver,
  withStateHandlers,
  withCappedProducts,
  withObserverLifecycle
)(TireLinesList)
